import React from 'react';
import MonthlyComponentsChart from './MonthlyComponentsChart';
import 'katex/dist/katex.min.css';
import TeX from '@matejmazur/react-katex';

const DecompositionComponent = (props) => {
  return (
    <div class="container">
      <h3>Monthly Anthrax Cases Series Decomposition Chart</h3>
      <MonthlyComponentsChart />
      <hr />
      <p>
        We used the&nbsp;
        <a href="https://www.rdocumentation.org/packages/stats/versions/3.6.2/topics/decompose">
          <i>Classical Seasonal Decomposition</i>
        </a>
        &nbsp;in R to decompose the Gannan anthrax time series into <i>trend</i>, <i>seasonal</i>, and <i>irregular</i> components using moving averages.
        Specifically, the origin time series could be reconstructed by additions of following components:
      </p>
      <p>
      <ul>
        <li><TeX math="T_t" />, the trend component at time <TeX math="t" />, reflecting the long-term progression, which was determined by a moving average (using a symmetric window with equal weights).</li>
        <li><TeX math="S_t" />, the seasonal component at time <TeX math="t" />, reflecting seasonality, which was computed by averaging for each time unit over all periods.</li>
        <li><TeX math="e_t" />, the irregular component at time <TeX math="t" />, reflecting random influences.</li>
      </ul>
        That is:
        <TeX block>{
          String.raw`y_t = T_t + S_t + e_t.`
        }</TeX>
      </p>
    </div>
  );
}

export default DecompositionComponent;